function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 21a.997.997 0 00.707-.293l8-8a.999.999 0 000-1.414l-8-8a.999.999 0 10-1.414 1.414L14.586 12l-7.293 7.293A.999.999 0 008 21z",
  fill: "currentColor"
});

function SvgIconChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDIxYS45OTcuOTk3IDAgMDAuNzA3LS4yOTNsOC04YS45OTkuOTk5IDAgMDAwLTEuNDE0bC04LThhLjk5OS45OTkgMCAxMC0xLjQxNCAxLjQxNEwxNC41ODYgMTJsLTcuMjkzIDcuMjkzQS45OTkuOTk5IDAgMDA4IDIxeiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { SvgIconChevron as ReactComponent };